"use strict";
const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
export function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
export function randomString(length = 10) {
  let text = "";
  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}
export function shouldUpdatePosition(targetRect) {
  return !(targetRect.x === 0 && targetRect.y === 0 && targetRect.width === 0 && targetRect.height === 0);
}
